
import useOmeMeetOrgUnitContactData from '../../../../../state/omeMeetOrgUnitContact/UseOmeMeetOrgUnitContactData';

import Constants from '@usas/ui-web/utils/Constants';

const useOrgUnitAdminContacts = () => {
  const { omeMeetOrgUnitContactState } = useOmeMeetOrgUnitContactData();

  return {
    omeMeetOrgUnitContactState,
    isLoading: omeMeetOrgUnitContactState.isArrayLoading,
    Constants
  };
}

export default useOrgUnitAdminContacts;